module.exports = __webpack_public_path__ + "static/img/zhuanpan.c12b1719.png";